var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreemelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.201,
    height: 42.59,
    viewBox: "0 0 170.201 42.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freemelt-log_whitetext",
    transform: "translate(0.006 0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M22.27,2.368a11,11,0,0,0-4.639,7.709,12.162,12.162,0,0,0-4.926-.94,11.949,11.949,0,0,0-4.668,1.156A8.5,8.5,0,0,1,15.764,0,8.267,8.267,0,0,1,22.27,2.368",
    fill: "#a0cb86",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M34.521,4.43a11.466,11.466,0,0,0-5.182,8.247,11.79,11.79,0,0,0-8.073-.012c-.553-.473-1.046-1-1.647-1.428.324-5.051,3.54-8.343,8.36-8.871A8.7,8.7,0,0,1,34.521,4.43",
    fill: "#32bfd8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M36.882,22.822A11.712,11.712,0,0,0,31.327,13.6a9.288,9.288,0,0,1,2.805-6.267,9.58,9.58,0,0,1,6.367-2.8,9.365,9.365,0,0,1,7.65,3.287A9.656,9.656,0,0,1,50.3,16.142a9.366,9.366,0,0,1-4.631,6.29,10.094,10.094,0,0,1-4.2,1.261,9.849,9.849,0,0,1-4.589-.871",
    fill: "#71bc88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M19.267,13.566a11.594,11.594,0,0,0-5.555,8.549,12.134,12.134,0,0,0-9.462.555,9.218,9.218,0,0,1,1.565-7.963,9.168,9.168,0,0,1,13.452-1.141",
    fill: "#04a156",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M21.221,32.258a11.664,11.664,0,0,0-5.555-9.221,9.663,9.663,0,0,1,2.806-6.3,9.83,9.83,0,0,1,6.4-2.768A9.6,9.6,0,0,1,30.007,31.9c-2.2,1.248-6.15,1.792-8.786.356",
    fill: "#c5d05f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M9.245,23.441a9.541,9.541,0,0,1,6.978,2.641,9.248,9.248,0,0,1,2.969,6.571A9.159,9.159,0,0,1,16.585,39.6a9.475,9.475,0,0,1-6.57,2.971A9.454,9.454,0,0,1,3,39.959,9.235,9.235,0,0,1,0,33.42a9.534,9.534,0,0,1,9.245-9.979",
    fill: "#04aa7d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M64,14.031V12.01c0-3.215,1.823-4.276,4.772-4.276.829,0,1.624.033,2.453.1v3.247a8.375,8.375,0,0,0-.895-.032c-1.293,0-1.757.4-1.757,1.424v1.558h2.652v3.115H68.575V31.861H64V17.146",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M72.818,14.031h4.375v2.386h.066c.928-1.723,2.221-2.85,4.11-2.85a6.794,6.794,0,0,1,.828.067v4.374c-.463-.033-.961-.066-1.425-.066a3.086,3.086,0,0,0-3.38,3.214v10.7H72.818V14.031Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M87.766,23.643v1.425c0,2.087.564,4.142,2.254,4.142,1.524,0,2.154-1.159,2.42-3.347h4.109c-.166,4.144-2.154,6.462-6.463,6.462-6.627,0-6.894-5.1-6.894-9.545,0-4.772.929-9.212,7.094-9.212,5.336,0,6.527,3.579,6.527,9.047v1.028H87.766Zm4.673-2.718c-.1-2.718-.432-4.242-2.319-4.242-1.824,0-2.354,1.889-2.354,3.546v.7h4.673Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M103.112,23.643v1.425c0,2.087.564,4.142,2.254,4.142,1.524,0,2.154-1.159,2.42-3.347h4.109c-.166,4.144-2.154,6.462-6.463,6.462-6.627,0-6.894-5.1-6.894-9.545,0-4.772.929-9.212,7.094-9.212,5.336,0,6.527,3.579,6.527,9.047v1.028h-9.047Zm4.674-2.718c-.1-2.718-.432-4.242-2.319-4.242-1.824,0-2.354,1.889-2.354,3.546v.7h4.673Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M114.549,14.031h4.375v1.823h.065a5.087,5.087,0,0,1,4.508-2.287,3.914,3.914,0,0,1,4.11,2.85h.065a4.434,4.434,0,0,1,4.509-2.85c3.015,0,4.439,1.889,4.439,5.336V31.861h-4.573V19.4c0-1.491-.5-2.319-1.79-2.319-1.458,0-2.386.994-2.386,3.049V31.862H123.3V19.4c0-1.491-.5-2.319-1.789-2.319-1.459,0-2.387.994-2.387,3.049V31.862h-4.573V14.031Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M143.584,23.643v1.425c0,2.087.564,4.142,2.254,4.142,1.524,0,2.154-1.159,2.42-3.347h4.109c-.166,4.144-2.154,6.462-6.463,6.462-6.627,0-6.894-5.1-6.894-9.545,0-4.772.929-9.212,7.094-9.212,5.336,0,6.527,3.579,6.527,9.047v1.028h-9.047Zm4.674-2.718c-.1-2.718-.432-4.242-2.319-4.242-1.824,0-2.354,1.889-2.354,3.546v.7h4.673Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    width: 4.573,
    height: 22.934,
    transform: "translate(155.187 8.928)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M162.969,14.031v-5.1h4.574v5.1h2.652v3.115h-2.652v9.645c0,1.391.3,1.955,1.624,1.955a9.26,9.26,0,0,0,1.028-.067v3.183a28.637,28.637,0,0,1-2.984.2c-3.579,0-4.242-1.093-4.242-4.706V17.146",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreemelt);
export default __webpack_public_path__ + "static/media/freemelt.f2036b4e7ffce35f8c81abf8a58794fd.svg";
export { ForwardRef as ReactComponent };